import DataController from '../data/data.controller';
import NavigationController from './navigation.controller';
import { getAuthCookie } from '../utils/cookies';

class ClockoutController extends NavigationController {
    user = null;
    data = new DataController();
    static _authSubscribers = new Set(); // Track all mounted instances

    // Get current auth state
    get isAuthenticated() {
        return getAuthCookie() !== 'expired';
    }

    // Called when auth state changes (login/logout)
    static _notifyAuthChange() {
        this._authSubscribers.forEach(instance => {
            if (instance.onAuthChange) instance.onAuthChange();
        });
    }

    async initialize() {}

    async cleanup() {}

    async componentDidMount() {
        this.constructor._authSubscribers.add(this);
        if (!this.data.user) {
            this.user = await this.data.fetchUserByToken();
        } else {
            this.user = this.data.user;
        }
        await this.initialize();
    }

    componentWillUnmount() {
        this.cleanup();
        this.constructor._authSubscribers.delete(this);
    }
}

export default ClockoutController;
